<template>
  <v-data-table
    :headers="headers"
    :items="recapiti"
    sort-by="tipo"
    class="elevation-1"
    dense
    hide-default-footer
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-dialog v-model="dialog" max-width="1000px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" dense>
              Nuovo recapito
            </v-btn>
            <v-spacer></v-spacer>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4" >
                   <!--  <v-text-field v-model="editedItem.tipo" label="Tipo"></v-text-field> -->
                    <v-select v-model="editedItem.tipo" :items="tipiDestinazione" label="Tipo" item-text="descrizione" item-value="codice" hide-details :return-object="true"></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.indirizzo" label="Indirizzo"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.localita" label="Localita" ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.cap" label="Cap" maxlength="5"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.provincia" label="Provincia (es. PG)" :rules="[rules.twoChars]" maxlength="2"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <!-- <v-text-field v-model="editedItem.nazione" label="Nazione (es. IT)"></v-text-field> -->
                    <v-autocomplete
                      v-model="editedItem.paese"
                      :items="itemsPaesi"
                      no-data-text="Cerca una nazione per codice o descrizione"
                      dense flat
                      label="Nazione"
                      item-text="descrizione"
                      item-value="codice"
                      clearable
                      :return-object="true"
                      hide-details
                      @click="value=''"
                      class="mt-5"
                    >
                    </v-autocomplete>                        
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.telefono" label="Telefono"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.cellulare" label="Cellulare"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                  </v-col>                        
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="close"
              >
                Annulla
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
              >
                Salva
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Sei sicuro di voler cancellare questo recapito?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Annulla</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogMessaggio" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Messaggio da inviare</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <v-textarea v-model="messaggioDaInviare" label="Messaggio" outlined dense></v-textarea>
                   </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeMessaggio"
              >
                Annulla
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="inviaMessaggio"
              >
                Invia
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>        
      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small
        class="mr-2"
        title="Modifica il recapito"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        class="mr-2"
        title="Cancella il recapito"
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
      <v-icon
        v-if="invioMessaggiAbilitato && item.cellulare"
        small
        title="Invia un messaggio"
        @click="inviaMessaggioItem(item)"
      >
        mdi-message-arrow-right-outline
      </v-icon>      
    </template>
    <template v-slot:no-data>
      Nessun recapito definito
<!--       <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn> -->
    </template>
  </v-data-table>
</template>

<script>
  import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService'
  import tabelle from '@/services/tabelleService'
  import messaggi from '@/services/messaggiService'
  import { buildDestinatario } from '@/helpers/messaggi.js'
 
  /* eslint-disable */
  export default {
    props: {
      idCliente: String,
      recapiti: Array
    },
    data: () => ({
      dialog: false,
      dialogDelete: false,
      dialogMessaggio: false,
      headers: [
        {
          text: 'Tipo',
          align: 'start',
          sortable: false,
          value: 'tipo.descrizione',
        },
        { text: 'Indirizzo', value: 'indirizzo' },
        { text: 'Localita', value: 'localita' },
        { text: 'Cap', value: 'cap' },
        { text: 'Provincia', value: 'provincia' },
        { text: 'Nazione', value: 'nomeNazione' },
        { text: 'Telefono', value: 'telefono' },
        { text: 'Cellulare', value: 'cellulare' },
        { text: 'Email', value: 'email' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      // recapiti: [],
      editedIndex: -1,
      editedItem: {
        tipo: '',
        indirizzo: '',
        localita: '',
        cap:  '',
        provincia:  '',
        nazione:  '',
        telefono: '',
        cellulare: '',
        email: ''
      },
      defaultItem: {
        tipo: { codice: 'principale', descrizione: 'Sede' },
        indirizzo:  '',
        localita:  '',
        cap:  '',
        provincia: '',
        nazione:  '',
        telefono: '',
        cellulare: '',
        email: ''
      },
      tipiDestinazione: [],
      itemsPaesi: [],
      rules: {
        twoChars: value => !value || value.length == 2 || 'Inserire la sigla della provincia (2 caratteri)',
      },
      messaggioDaInviare: '',
      abilitaInvioMessaggi: false,
      mittenteMessaggi: null
    }),
    async created() {
      const stati = await tabelle.getTabella('anagrafica_stati', 'stati')
      this.itemsPaesi = stati.map(x => {
        return {
          codice: x.alfa2,
          descrizione: x.descrizione
        }
      })      
    },
    async mounted() {
      this.tipiDestinazione = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDestinazione')
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')

      this.abilitaInvioMessaggi = _.get(impostazioni, 'messaggi.abilitaInvio', false)
      this.mittenteMessaggi = _.get(impostazioni, 'messaggi.mittente')
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuovo recapito' : 'Modifica recapito'
      },
      invioMessaggiAbilitato() {
        // TODO: Vincolari alla licenza messaggi + abilitazione su impostzioni
        return this.abilitaInvioMessaggi
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      gialogMessaggio (val) {
        val || this.closeMessaggio()
      }
    },
    methods: {
      inviaMessaggioItem(item) {
        this.editedIndex = this.recapiti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogMessaggio = true        
      },
      editItem (item) {
        this.editedIndex = this.recapiti.indexOf(item)
        if (item) {
          let paese = _.get(item, 'paese')
          if (!paese) {
            if (item.nazione) {
              paese = this.itemsPaesi.find(x => x.codice === item.nazione)
            } else {
              paese = { codice: 'IT', descrizione: 'Italia' }
            } 
            _.set(item, 'paese', { ...paese })
          }
        }           
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.recapiti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.$emit('delete-recapito', { idCliente: this.idCliente, address: this.editedItem })
        this.recapiti.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeMessaggio () {
        this.dialogMessaggio = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        // TODO: nazione e nomeNazione lasciati per retro compatibilità, verificare se togliere (att.ne fatturazione) 
        this.editedItem.nazione = this.editedItem.paese.codice
        this.editedItem.nomeNazione = this.editedItem.paese.descrizione
        if (this.editedIndex > -1) {
          Object.assign(this.recapiti[this.editedIndex], this.editedItem)
          this.$emit('update-address', { idCliente: this.idCliente, address: this.editedItem })
        } else {
          this.$emit('new-address', { idCliente: this.idCliente, address: this.editedItem })
          this.recapiti.push(this.editedItem)
        }
        this.close()
      },
      async inviaMessaggio() {
        const destinatari = buildDestinatario(this.editedItem)
        if (this.mittenteMessaggi && this.messaggioDaInviare && destinatari && destinatari.length > 0) {
          const results = await messaggi.inviaMessaggioSingolo(this.mittenteMessaggi, destinatari, this.messaggioDaInviare)
          console.log(results)  // TODO: Visualizzare stato ed archiviare su cliente/messagggi/inviati ... E' possibile leggere anche le risposte con webhook
          this.editedItem.messaggi = this.editedItem.messaggi || []
          this.editedItem.messaggi.push({
            mittente: this.mittenteMessaggi,
            destinatari,
            messaggio: this.messaggioDaInviare
          })
          await this.save()
          this.messaggioDaInviare = ''
        }
        this.closeMessaggio()
      }
    }
  }
</script>
